module.exports = __webpack_public_path__ + "img/sc.4073a73e.png";